module.exports = __webpack_public_path__ + "static/media/grillme_qa_show.13f0f4fb.png";